import { render, staticRenderFns } from "./discussvote.vue?vue&type=template&id=5184f71a&scoped=true&"
import script from "./discussvote.vue?vue&type=script&lang=js&"
export * from "./discussvote.vue?vue&type=script&lang=js&"
import style0 from "./discussvote.vue?vue&type=style&index=0&id=5184f71a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5184f71a",
  null
  
)

export default component.exports